export default __webpack_public_path__ + "static/mpharma-a4967e177f2694a42f73abd81acd25f7.svg";